import { render, staticRenderFns } from "./tabInternationalCardBase.vue?vue&type=template&id=39a70bf0&scoped=true&"
import script from "./tabInternationalCardBase.vue?vue&type=script&lang=js&"
export * from "./tabInternationalCardBase.vue?vue&type=script&lang=js&"
import style0 from "./tabInternationalCardBase.vue?vue&type=style&index=0&id=39a70bf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a70bf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a70bf0')) {
      api.createRecord('39a70bf0', component.options)
    } else {
      api.reload('39a70bf0', component.options)
    }
    module.hot.accept("./tabInternationalCardBase.vue?vue&type=template&id=39a70bf0&scoped=true&", function () {
      api.rerender('39a70bf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/tabs/tabInternationalCardBase.vue"
export default component.exports